import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import ReactMarkdown from 'react-markdown/with-html';
import Lesson from './utils/Lesson';
import './StepLesson.css';

function createLessonListHtml(lesson, stepNum0) {
  const lessonList = [];
  lesson.steps.forEach((step, idx) => {
    const lessonLink = '//' + window.location.host + window.location.pathname;
    const stepPermalink = lessonLink + '?step=' + step.slug();
    const isActive = stepNum0 === idx;
    let lessonItem = (
      <ListGroup.Item
        action
        href={stepPermalink}
        key={`ll_${idx}`}
        active={isActive}
      >
        <Row>
          <Col xs={2} sm={2} md={1} lg={1}>
            {idx + 1}
          </Col>
          <Col xs={4} sm={4} md={3} lg={2}>
            <small>{step.type()}</small>
          </Col>
          <Col xs={6} sm={6} md={8} lg={9}>
            {step.name()}
          </Col>
        </Row>
      </ListGroup.Item>
    );
    lessonList.push(lessonItem);
  });
  return <ListGroup variant="flush">{lessonList}</ListGroup>;
}

function StepLesson(props) {
  const { lessonSlug, lessonJsonFile } = props;

  const curUrl = new URL(window.location);
  const urlStep = curUrl.searchParams.get('step');

  const [showLessonList, setShowLessonList] = useState(false);
  const [showImageFn, setShowImageFn] = useState('');
  const [showImageModal, setShowImageModal] = useState(false);
  const [lesson, updateLesson] = useState(null);
  const [stepSlug, updateStepSlug] = useState(urlStep);
  const [highlightImages, updateHighlightImages] = useState([]);
  //if (lessonSlug === 'build-hadabotxx' && lesson == null) {
  //  const newLesson = new Lesson({ lessonDefinition: buildHadabotLesson });
  //  const newFirstLessonSlug = newLesson.stepAtIdx0(0).slug();
  //  updateLesson(newLesson);
  //  if (stepSlug == null) {
  //    updateStepSlug(newFirstLessonSlug);
  //  }
  //} else
  if (lesson == null) {
    let oReq = new XMLHttpRequest();
    oReq.onload = function (e) {
      let lessonJson = JSON.parse(oReq.responseText);
      lessonJson.steps.forEach((sss, idx) => {
        if (sss.descriptionMd !== undefined) {
          // Old way of defining one contiguous MD block, so just convert the
          // big array of strings into a single block
          sss.descriptionMdBlocks = [
            {
              descriptionMd: sss.descriptionMd.join('\r\n'), //'  \n');
            },
          ];
          delete sss.descriptionMd;
        } else if (sss.descriptionMdBlocks !== undefined) {
          const newMdBlocks = [];
          sss.descriptionMdBlocks.forEach((desc, idx) => {
            if (Array.isArray(desc)) {
              // Is just an array of text - change to a struct
              desc = {
                descriptionMd: desc.join('\r\n'),
              };
            } else {
              // Already a struct so just join the lines
              desc.descriptionMd = desc.descriptionMd.join('\r\n');
            }
            newMdBlocks.push(desc);
          });
          sss.descriptionMdBlocks = newMdBlocks;
        }
      });
      const newLesson = new Lesson({ lessonDefinition: lessonJson });
      const newFirstLessonSlug = newLesson.stepAtIdx0(0).slug();
      updateLesson(newLesson);
      if (stepSlug == null) {
        updateStepSlug(newFirstLessonSlug);
      }
    };
    oReq.open('get', `/theme/sl-content/${lessonJsonFile}`, true);
    oReq.send();
  }

  if (lesson == null || stepSlug == null) {
    return <div />;
  }

  const lessonLink = '//' + window.location.host + window.location.pathname;
  const stepPermalink = lessonLink + '?step=' + stepSlug;

  const step = lesson.step(stepSlug);

  // Invalidate step just defaults back to first step
  if (step == null) {
    window.location = lessonLink;
  }

  const stepIdx = lesson.stepIdx0(stepSlug);
  const totalSteps = lesson.numSteps();
  const nextStep = lesson.nextStep(stepSlug);
  const prevStep = lesson.prevStep(stepSlug);

  const theStepType = step.type();
  let stepType = '';
  if (theStepType !== '') {
    stepType = `${theStepType}`;
  }

  let stepNumber = '';
  if (stepIdx >= 0) {
    stepNumber = `Step ${stepIdx + 1} of ${totalSteps}`;
  }

  const imageComponents = [];
  step.images().forEach((fn, idx) => {
    let imageFn = fn;
    if (fn.startsWith('http') === false) {
      imageFn = `/theme/images/${lesson.imageSubPath}${fn}`;
    }
    let colWidth = 12;
    let colOffset = 0;
    let imageClass = 'p-2';
    if (highlightImages.length > 0) {
      if (highlightImages.includes(fn) === false) {
        // Highlighting relevant images, make this smaller since it is
        // NOT relevant
        colWidth = 6;
        colOffset = 3;
      } else {
        // Circle the relevant images
        imageClass += ' shadow-lg bg-white rounded';
      }
    }
    imageComponents.push(
      // eslint-disable-next-line react/no-array-index-key
      <Col
        xs={{ span: colWidth, offset: colOffset }}
        className="mb-2"
        key={`${idx}_${fn}`}
      >
        <Image
          src={imageFn}
          onClick={() => {
            window.mixpanel.track('step_lesson', {
              action: 'show_image_modal',
              lesson_slug: lessonSlug,
              step_slug: stepSlug,
              image: imageFn,
            });
            setShowImageFn(imageFn);
            setShowImageModal(true);
          }}
          fluid
          rounded
          className={imageClass}
        />
      </Col>
    );
  });

  // Only 1 next step for now (undo functionality not implemented)
  let nextStepComponent = '';
  if (nextStep != null) {
    nextStepComponent = (
      <Button
        variant="primary"
        onClick={() => {
          window.mixpanel.track('step_lesson', {
            action: 'next_button_click',
            lesson_slug: lessonSlug,
            step_slug: stepSlug,
            next_step_slug: nextStep.slug(),
          });
          updateHighlightImages([]);
          updateStepSlug(nextStep.slug());
        }}
      >
        Next
      </Button>
    );
  } else {
    const lessonName = window.location.pathname
      .replace('/', '')
      .replace('.html', '');
    const currUrl = `/build-learn.html?previous-lesson=${lessonName}`;
    nextStepComponent = (
      <Button href={currUrl} variant="primary">
        Next Lesson
      </Button>
    );
  }

  let undoBackButtonComponent = '';
  if (prevStep != null) {
    undoBackButtonComponent = (
      <Button
        variant="outline-primary"
        onClick={() => {
          window.mixpanel.track('step_lesson', {
            action: 'previous_button_click',
            lesson_slug: lessonSlug,
            step_slug: stepSlug,
            prev_step_slug: prevStep.slug(),
          });
          updateHighlightImages([]);
          updateStepSlug(prevStep.slug());
        }}
      >
        Back
      </Button>
    );
  }

  // Are there images?
  let cardBodyDescriptColumnXs = 12;
  let cardBodyImageColumn = '';
  if (imageComponents.length > 0) {
    cardBodyImageColumn = (
      <Col xs={3}>
        <Row>{imageComponents}</Row>
      </Col>
    );
    cardBodyDescriptColumnXs = 9;
  }

  const llist = createLessonListHtml(lesson, stepIdx);
  let llistCardFooter = '';
  if (true || showLessonList) {
    llistCardFooter = (
      <Collapse in={showLessonList}>
        <div id="llist-collapse-text">
          <Card.Body className="pr-0 pl-0 pt-0 pb-0">{llist}</Card.Body>
          <Card.Footer>
            <Row className="align-items-center">
              <Col xs={10} className="text-left">
                <ButtonGroup>
                  <Button
                    aria-expanded={showLessonList}
                    aria-controls="llist-collapse-text"
                    variant="outline-primary"
                    onClick={() => {
                      setShowLessonList(!showLessonList);
                    }}
                  >
                    Hide
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card.Footer>
        </div>
      </Collapse>
    );
  }

  // The lesson contents.
  const lessonDescription = [];
  step.descriptionMdBlocks().forEach((mdBlock, idx) => {
    let imageRefs = [];
    let clickForMore = '';
    let rowClass = '';
    if (mdBlock.imageRefs !== undefined) {
      // Associated images
      imageRefs =
        highlightImages !== mdBlock.imageRefs ? mdBlock.imageRefs : [];
      rowClass += ' mb-1 bg-light border-left border-secondary';
      clickForMore =
        '<br/><span class="text-secondary"><small>\\[Click paragraph to show/hide relevant images\\]</small></span>';
    }
    lessonDescription.push(
      <Row key={`descriptionMd_${idx}`} className={rowClass}>
        <Col onClick={() => updateHighlightImages(imageRefs)}>
          <ReactMarkdown
            escapeHtml={false}
            source={`${mdBlock.descriptionMd}${clickForMore}`}
          />
        </Col>
      </Row>
    );
  });

  return (
    <div>
      <Row>
        <Col xs={12} className="pb-4">
          <h1>{lesson.lessonName()}</h1>
        </Col>
        <Col xs={12}>
          <Card className="text-dark text-left">
            <Card.Body>
              <Row className="align-items-center">
                <Col xs={5} sm={7} md={8}>
                  <Row className="align-items-center">
                    <Col xs={12}>
                      <strong className="text-primary">{`${stepType}`}</strong>
                    </Col>
                    <Col xs={12}>
                      <small>{`${stepNumber}`}</small>
                    </Col>
                    <Col xs={12}>{`${step.name()}`}</Col>
                  </Row>
                </Col>
                <Col xs={7} sm={5} md={4} className="text-right">
                  <ButtonGroup className="mr-1">
                    <Button
                      aria-expanded={showLessonList}
                      aria-controls="llist-collapse-text"
                      variant="outline-primary"
                      onClick={() => {
                        setShowLessonList(!showLessonList);
                      }}
                    >
                      <i className="fas fa-ellipsis-v"></i>
                    </Button>
                  </ButtonGroup>
                  <ButtonGroup>
                    {undoBackButtonComponent}
                    {nextStepComponent}
                  </ButtonGroup>
                </Col>
              </Row>
            </Card.Body>
            {llistCardFooter}
          </Card>

          <Card className="text-dark text-left mt-3">
            <Card.Body>
              <Row>
                {cardBodyImageColumn}

                <Col xs={cardBodyDescriptColumnXs}>{lessonDescription}</Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Row className="align-items-center">
                <Col xs={10} className="text-left">
                  <ButtonGroup>
                    {undoBackButtonComponent}
                    {nextStepComponent}
                  </ButtonGroup>
                </Col>
                <Col xs={2} className="text-right">
                  <small>
                    <a href={stepPermalink} title="Permalink to this step">
                      <i className="fas fa-link"></i>
                    </a>
                  </small>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <Modal
        show={showImageModal}
        dialogClassName="modal-90w"
        onHide={() => {
          setShowImageModal(false);
        }}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="text-center">
            <Image src={showImageFn} fluid rounded />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowImageModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

StepLesson.propTypes = {
  lessonSlug: PropTypes.string.isRequired,
};

export default StepLesson;
